export default "__VITE_ASSET__04BPWQeg__"